import { render, staticRenderFns } from "./BulletinListAdd.vue?vue&type=template&id=25d6860c"
import script from "./BulletinListAdd.vue?vue&type=script&lang=js"
export * from "./BulletinListAdd.vue?vue&type=script&lang=js"
import style0 from "./BulletinListAdd.vue?vue&type=style&index=0&id=25d6860c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports